import { clientLoadMore } from '../util/loadMore';

export default {
  init() {
    const button = document.getElementById('js-load-more');
    if (!button) return;
    button.addEventListener('click', () => {
      clientLoadMore({
        button,
        withAjax: false,
        increment: 5,
        listId: 'js-results',
        itemClass: 'js-result-item',
      });
    })
  },
};
